export const ACTIONS_POSTINGS = {
  ADD_POSTINGS: 'ADD_SHIPMENT_POSTINGS',
  ADD_MAP: 'ADD_SHIPMENT_MAP',
  CHANGE_POSTING: 'CHANGE_SHIPMENT_POSTING',
  CHANGE_POSTING_MANY: 'CHANGE_SHIPMENT_POSTING_MANY',
};

export const addShipmentPostings = data => ({
  type: ACTIONS_POSTINGS.ADD_POSTINGS,
  data,
});

export const addShipmentPostingsMap = (map = {}) => ({
  type: ACTIONS_POSTINGS.ADD_MAP,
  map,
});

export const changeShipmentPosting = (newById = {}) => ({
  type: ACTIONS_POSTINGS.CHANGE_POSTING,
  newById,
});

export const changeShipmentPostingMany = (newByIds = {}) => ({
  type: ACTIONS_POSTINGS.CHANGE_POSTING_MANY,
  newByIds,
});
